import { isEmpty } from "lodash";

const isAnswerEmpty = (answer) => isEmpty(answer) || answer === " ";
const isUnityPredicted = (answer: any = {}) => answer?.userName === "UnityPredictedAnswer";
const isCarryForwarded = (answer: any = {}) => answer.userName === "CarryForwardAnswer";

function parseJSON(jsonString: string): any {
  try {
    return JSON.parse(jsonString);
  } catch (error) {
    return jsonString;
  }
}

export function getLatestAnswer(answers: any[]) {
  let lastAnswer: any = {};
  try {
    if (Array.isArray(answers) && answers.length > 0) {
      const answersArr = answers;
      lastAnswer = answersArr[answersArr.length - 1];
    }
    return lastAnswer;
  } catch (error) {
    console.error(error);
    return lastAnswer;
  }
}

export function isLatestAnswerEmpty(answers: any[]): boolean {
  return (
    isEmpty(answers) ||
    (Array.isArray(answers[answers.length - 1].answer) && answers[answers.length - 1].answer.length === 0) ||
    (typeof answers[answers.length - 1].answer === "string" &&
      (answers[answers.length - 1].answer.trim() === "" ||
        answers[answers.length - 1].answer.trim() === " " ||
        answers[answers.length - 1].answer.trim() === "N/A")) ||
    !answers[answers.length - 1].answer
  );
}

export function isLatestAnswerUnverified(answers: any): boolean {
  const latestAnswer: any = getLatestAnswer(answers);
  if (!isAnswerEmpty(latestAnswer.answer) && (isUnityPredicted(latestAnswer) || isCarryForwarded(latestAnswer)))
    return true;
  return false;
}

export function copyToClipBoard(content: any): void {
  const blob = new Blob([content], { type: "text/html" });
  const clipboardItem = new window.ClipboardItem({ "text/html": blob });
  navigator.clipboard.write([clipboardItem]);
}

export function generateRegexForEditor(): RegExp {
  const editorRegex1 =
    /<div data-contents="true"><div data-block="true" data-editor="[A-Za-z0-9]+" data-offset-key="([A-Za-z0-9]+(-[A-Za-z0-9]+)+)"><div data-offset-key="([A-Za-z0-9]+(-[A-Za-z0-9]+)+)" class="public-DraftStyleDefault-block public-DraftStyleDefault-ltr">/g;
  const editorRegex2 =
    /<div data-block="true" data-editor="[A-Za-z0-9]+" data-offset-key="([A-Za-z0-9]+(-[A-Za-z0-9]+)+)"><div data-offset-key="([A-Za-z0-9]+(-[A-Za-z0-9]+)+)" class="public-DraftStyleDefault-block public-DraftStyleDefault-ltr">/g;
  const editorRegex3 =
    /<div data-block="true" data-editor="[A-Za-z0-9]+" data-offset-key="([A-Za-z0-9]+(-[A-Za-z0-9]+)+)" class="([A-Za-z0-9]+(-[A-Za-z0-9]+)+)"><div data-offset-key="([A-Za-z0-9]+(-[A-Za-z0-9]+)+)" class="public-DraftStyleDefault-block public-DraftStyleDefault-ltr">/g;
  return new RegExp(editorRegex1.source + "|" + editorRegex2.source + "|" + editorRegex3.source, "g");
}

export function generateRegexForDiv(): RegExp {
  const divRegex1 = /<\/div><\/div><\/div>/g;
  const divregex2 = /<\/div><\/div>/g;
  return new RegExp(divRegex1.source + "|" + divregex2.source, "g");
}

export function mergeStringWithNewLine(str1: string, str2: string): string {
  const editorRegex = generateRegexForEditor();
  const divRegex = generateRegexForDiv();
  if (str2 === "No Answer") return str1.replace(editorRegex, "").replace(divRegex, "").trim();
  if (/<\/?[a-z][\s\S]*>/i.test(str2)) {
    if (/<ul | <ol/g.test(str2)) return str1 + str2;
    return (
      str1.replace(editorRegex, "").replace(divRegex, "").trim() +
      str2.replace(editorRegex, "<br />").replace(divRegex, "").trim()
    );
  }
  return str1.replace(editorRegex, "").replace(divRegex, "").trim() + "<br />" + str2;
}

export function getBidType(bidType: string): string {
  if (bidType === "Post_Award_Bid") return "Post Award";
  if (bidType === "RFI_Request") return "RFI";
  if (bidType === "Early_Engagement_Bid") return "Early Engagement";
  if (bidType === "Clinical_Bid") return "Bid";
  if (bidType === "Non_RFP_Bid") return "Ballpark"; // ballpark bid type
  return bidType;
}

export function getFormattedTableData(data: any): any {
  const parseData = parseJSON(data);
  const columns = parseData["columns"]
    .filter((col: any) => col.hidden !== true)
    .reduce((acc: Array<string>, curr: any) => acc.concat(curr.accessor), []);
  const rows = parseData["rows"]
    .filter((row: any) => row.hidden !== true)
    .map((row: any) => columns.map((column: any) => row[column]));
  const columnHeaders = parseData["columns"]
    .filter((col: any) => col.hidden !== true)
    .reduce(
      (acc: Array<string>, curr: any) => (curr.accessor === "header" ? acc.concat("") : acc.concat(curr.header)),
      []
    );
  rows.splice(0, 0, columnHeaders);
  return rows;
}
